<template>
  <div>
    <!-- Breadcrumb Area -->
    <Breadcrumb mainTitle="Sign In" breadContent="Placeholder" subTitle="Sign In" />
    <div class="container mt-12 mb-12">
      <div class="row">
        <div class="col-lg-4 col-md-8 col-12 mx-auto">
          <div class="card z-index-0 fadeIn3 fadeInBottom">
            <div class="card-header p-0 position-relative mt-n4 mx-3 z-index-2">
              <div class="bg-gradient-success shadow-success border-radius-lg py-3 pe-1">
                <h4 class="text-white font-weight-bolder text-center mt-2 mb-0">
                  Sign in
                </h4>
                <div class="row mt-3">
                  <div class="col-2 text-center ms-auto">
                    <a class="btn btn-link px-3" href="javascript:;">
                      <i class="fab fa-facebook-f text-white text-lg"></i>
                    </a>
                  </div>
                  <div class="col-2 text-center px-1">
                    <a class="btn btn-link px-3" href="javascript:;">
                      <i class="fab fa-github text-white text-lg"></i>
                    </a>
                  </div>
                  <div class="col-2 text-center me-auto">
                    <a class="btn btn-link px-3" href="javascript:;">
                      <i class="fab fa-google text-white text-lg"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-body">
              <form @submit.prevent="handleSignIn" role="form" class="text-start">
                <MaterialInput id="email" v-model="email" class="input-group-outline my-3" placeholder="Email"
                  type="email" />
                <MaterialInput id="password" v-model="password" class="input-group-outline mb-3" placeholder="Password"
                  type="password" />
                <MaterialSwitch v-model="rememberMe" class="d-flex align-items-center mb-3" id="rememberMe"
                  labelClass="mb-0 ms-3" checked>Remember me</MaterialSwitch>

                <div class="text-center">
                  <MaterialButton class="my-4 mb-2" variant="gradient" color="success" fullWidth>Sign in
                  </MaterialButton>
                </div>
                <p v-if="errorMessage" class="text-danger text-center">{{ errorMessage }}</p>
                <!-- Display any error messages -->
                <p class="mt-4 text-sm text-center">
                  Don't have an account?
                  <router-link to="/sign-up" class="text-success text-gradient font-weight-bold">
                    Sign up
                  </router-link>
                </p>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>


  </div>
</template>

<script>
import Breadcrumb from '@/components/Breadcrumb.vue'
import MaterialInput from "@/components/MaterialInput.vue";
import MaterialSwitch from "@/components/MaterialSwitch.vue";
import MaterialButton from "@/components/MaterialButton.vue";
import axios from 'axios';
import '@fortawesome/fontawesome-free/css/all.css'

export default {
  name: 'SignIn',
  components: { Breadcrumb, MaterialInput, MaterialSwitch, MaterialButton },
  data() {
    return {
      email: '',
      password: '',
      rememberMe: false,
      errorMessage: ''
    };
  },
  methods: {
    async handleSignIn() {
      try {
        console.log('Attempting login with:', this.email, this.password);  // Log input data
        const response = await axios.post('http://172.96.161.120:7675/login', {
          email: this.email,
          password: this.password
        });
        console.log('Response:', response.data);
      } catch (error) {
        console.error('Login failed:', error.response?.data || error.message);
      }
    }
  },
  async mounted() {

    //scrolling to top of the window
    window.scrollTo(0, 0);

  }

}
</script>